<template>
<div>
  <div class="page tableofcontents">
    <br>
    <p class="dustin preheader">
      Asset Class
    </p>
    <p class="dustin-title ">
      Sovereign
    </p>
    <br>
    <p class="description">
      Impact of Investing in Sovereigns
    </p>
    <p class="criteria">
      Sovereign bonds are direclty tied to the general treasury operations of nation states. While these issuances are not tied to specific projects, but are intimately linked to the fiscal and monetary policies of governments. 
    </p>
    <br>
    <!-- columns --> 
    <div class="columns">
      <div class="column is-half">
        <p class="description">
          NDC Commitments
        </p>
        <p class="criteria">
          Countries have set targets after the 2015 Paris Climate Agreement to reduce their greenhouse gas emissions, implement climate adaptation plans, and to achieve objectives set forth in the Sustainable Development Goals.
        </p>
      </div>
      <div class="column is-half">
        <div class="description">
          Methodology
        </div>
        <div class="criteria">
          Using publicly available NDC commitment data, this report tracks the dollar-weighted average of sovereigns in your portfolio are surpassing or underperforming progress towards their NDDC goals, filtered by issue. 
        </div>
      </div>
    </div>
    <p class="preheader has-text-centered">NDC-SDG Linkages</p>
    <br>
    <iframe src="https://www.climatewatchdata.org/embed/ndcs-sdg" frameborder="0" style="height: 900px; width: 1230px;        -ms-zoom: 0.75;
          -moz-transform: scale(0.55);
          -moz-transform-origin: 0 0;
          -o-transform: scale(0.55);
          -o-transform-origin: 0 0;
          -webkit-transform: scale(0.55);
          -webkit-transform-origin: 0 0;"></iframe>
      
    
    
  
    
  </div><!-- page-->
  <!-- <div class="page">
    <p class="preheader">
      Asset Class
    </p>
    <p class="dustin-title ">
      Sovereign
    </p>
    <br>
    <p class="preheader">
      NDC-SDG Highlights
    </p>
    <p class="description">
      Methodology
    </p>
    <p class="criteria">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, tempore! Perferendis repellendus pariatur iure excepturi, earum deserunt tempore quae fugit facere quasi et quam labore adipisci. Alias asperiores quis ea.
    </p>
    <br>
    
    <nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Your Fund</p>
      <p class="title">3,456</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Benchmark</p>
      <p class="title">123</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Peer Fund</p>
      <p class="title">456K</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Likes</p>
      <p class="title">789</p>
    </div>
  </div>
</nav>
    <nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Tweets</p>
      <p class="title">3,456</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Following</p>
      <p class="title">123</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Followers</p>
      <p class="title">456K</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Likes</p>
      <p class="title">789</p>
    </div>
  </div>
</nav>
    <nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Tweets</p>
      <p class="title">3,456</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Following</p>
      <p class="title">123</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Followers</p>
      <p class="title">456K</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Likes</p>
      <p class="title">789</p>
    </div>
  </div>
</nav>
    <nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Tweets</p>
      <p class="title">3,456</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Following</p>
      <p class="title">123</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Followers</p>
      <p class="title">456K</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Likes</p>
      <p class="title">789</p>
    </div>
  </div>
</nav>
    <nav class="level">
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Tweets</p>
      <p class="title">3,456</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Following</p>
      <p class="title">123</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Followers</p>
      <p class="title">456K</p>
    </div>
  </div>
  <div class="level-item has-text-centered">
    <div>
      <p class="heading">Likes</p>
      <p class="title">789</p>
    </div>
  </div>
</nav>



  </div> -->
</div>
</template>

<script>

 import BarChart from './subcomponents/BarChart.js'
 import DoughnutChart from './subcomponents/DoughnutChart.js'
 import LineChart from './subcomponents/LineChart.js'

  export default {
    components: {
      BarChart, LineChart
    },
    data () {
      return {
        datacollection: {},
        slrdata: {},
        bottomGraph: {},
        nolegend: {}
      }
    },
    mounted () {
      this.fillData(),
      console.log(this.datacollection)
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: ['Average Energy Rating', 'Energy Star'],
          datasets: [
            {
              backgroundColor: ['grey', 'green'],
              data: [this.getRandomInt(), this.getRandomInt()]
            }, 
          ]
        },
        this.slrdata = {
          labels: [this.getRandomInt(), this.getRandomInt()],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }, {
              label: 'Data One',
              backgroundColor: '#f87979',
              data: [this.getRandomInt(), this.getRandomInt()]
            }
          ]
        },
        this.nolegend = {
          maintainAspectRatio: false,
          legend: { display: false },
        },
        this.bottomGraph = {
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    },
  }

</script>

<style lang="css" scoped>
  .tableofcontents {
    padding: 6rem;
  }
  .chart-container-small {
    position: relative;
    height: 250px;
    width: 350px;
  }
  .bottomchart {
    height: 100px;
    width: 600px;
  }


</style>
